<tt-page *ngIf="!!itemsListBlockOrders">
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListBlockOrders"></tt-list>
</tt-page>
